<template>
  <el-dialog
    :visible.sync="showtag"
    class="del_row"
    width="400"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
    @close="closed"
  >
    <div class="del_row_frame">
      <p class="title">{{$t('components_del_row_index_2188')}}</p>
      <el-checkbox v-model="checked">{{$t('components_del_row_index_2189')}}</el-checkbox>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sure">{{$t('view_public_topbar_15')}}</el-button>
      <el-button @click="closed">{{$t('view_public_topbar_14')}}</el-button>
      
    </span>
  </el-dialog>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import { setRelationWidget } from "@/api/app";
export default {
  name: "del_row",
  data() {
    return {
      showtag: true,
      loading: false,
      checked: false
    };
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    rowType: {
      type: String,
      default: ""
    },
    row: {
      type: Object,
      default: null
    }
  },
  methods: {
    closed() {
      this.showtag = true;
      this.$emit("dialog_close");
    },
    sure() {
      if (this.checked) {
        this.setRelationWidget();

      }

      const list = this.$store.state.myRender[this.rowType];
      list.splice(this.index, 1);
      this.closed();
    },
    //设置关联挂件
    setRelationWidget() {
      const now_row = this.$store.state.page_add_row.row;
      setRelationWidget({
        widgets_id: this.row.widgets_id,
        //pages: this.get_page_data(arr, "has_now_page")
      }).then(e => {
        if (e.code == 200) {
          this.$message.success({
            showClose: true,
            message: i18n.t('components_del_row_index_2190')
          });
        } else {
          this.$message.success({
            showClose: true,
            message: i18n.t('components_del_row_index_2191')
          });
        }
      });
    }
  },
  computed: {},
  created() {},
  mounted() {},
  components: {}
};
</script>

<style lang="scss" scoped>
.del_row {
  /deep/ .el-dialog {
    position: absolute;
    top: 50%;
    left: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
    height: 200px;
    width: 500px;
    margin-top: -100px !important;
    .el-dialog__body {
      padding: 20px;
      .del_row_frame {
        text-align: center;
        .title {
          color: #333;
          font-size: 16px;
          line-height: 30px;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/del_row/index.vue